var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedliningNewActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1141_1087",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1141_1087)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.25646 17.9166C4.83549 17.9166 4.47917 17.7708 4.1875 17.4791C3.89583 17.1874 3.75 16.8311 3.75 16.4101V3.58971C3.75 3.16874 3.89583 2.81242 4.1875 2.52075C4.47917 2.22909 4.83549 2.08325 5.25646 2.08325H11.875L16.25 6.45825V9.12659C15.9519 9.17992 15.6733 9.27763 15.4142 9.41971C15.1551 9.56179 14.9156 9.74291 14.6954 9.96304L9.69542 14.9422V17.9166H5.25646ZM11.5225 17.9166V15.7147L16.0465 11.2114C16.1501 11.1132 16.2622 11.0417 16.3829 10.9968C16.5037 10.9519 16.6245 10.9295 16.7452 10.9295C16.8745 10.9295 17.0008 10.954 17.1242 11.003C17.2475 11.0522 17.3583 11.126 17.4567 11.2243L18.2275 12.003C18.3172 12.1068 18.3867 12.219 18.4358 12.3397C18.485 12.4604 18.5096 12.5811 18.5096 12.7018C18.5096 12.8225 18.4872 12.9453 18.4423 13.0703C18.3974 13.1953 18.3258 13.3096 18.2275 13.4133L13.7244 17.9166H11.5225ZM16.7452 13.5064L17.516 12.7018L16.7452 11.923L15.9535 12.7147L16.7452 13.5064ZM11.25 7.08325H15L11.25 3.33325V7.08325Z",
    fill: "black",
    fillOpacity: 0.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedliningNewActive);
export default __webpack_public_path__ + "static/media/redliningNewActive.52126173a6f6e00ce77fd4599fb421db.svg";
export { ForwardRef as ReactComponent };